export class NavLinkNode {
  constructor(
    public expandable: boolean,
    public level: number,
    public path: string[],
    public label: string,
    public icon?: string
  ) {}
}
